/* MOSS: autoplay Shopify-hosted videos.
   - Product gallery: hosted videos render inline inside <deferred-media>.
     A visibility sweep (plus scroll/click triggers) plays whichever gallery
     video is actually on screen — including 2nd/3rd slides in the mobile
     slider that the browser never autoplayed while off-screen — muted,
     looping and inline, the combination iOS requires.
   - Product cards: a card's hover video layer (.moss-card-video) is played
     while the card is on screen so the hover reveal is already moving. */
(function () {
  function prepVideo(v) {
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.setAttribute('webkit-playsinline', '');
    v.loop = true;
    v.autoplay = true;
    v.preload = 'auto';
    if (!v.__mossLoopHook) {
      v.__mossLoopHook = true;
      v.addEventListener('ended', function () {
        try { v.currentTime = 0; } catch (e) {}
        tryPlay(v);
      });
      var lastSeek = 0;
      v.addEventListener('timeupdate', function () {
        if (!v.duration || v.paused) return;
        var remaining = v.duration - v.currentTime;
        var now = Date.now();
        if (remaining < 0.35 && remaining > 0 && now - lastSeek > 1000) {
          lastSeek = now;
          try { v.currentTime = 0.05; } catch (e) {}
        }
      });
    }
  }
  function tryPlay(v) {
    prepVideo(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function arm(dm) {
    if (dm.__mossArmed) return;
    dm.__mossArmed = true;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      var v = dm.querySelector('video');
      if (!v) {
        if (typeof dm.loadContent === 'function' && !dm.getAttribute('loaded')) {
          try { dm.loadContent(false); } catch (e) {}
        }
        if (tries > 40) clearInterval(timer);
        return;
      }
      tryPlay(v);
      v.addEventListener('canplay', function () { if (v.paused) tryPlay(v); });
      [300, 800, 1600].forEach(function (ms) {
        setTimeout(function () { if (v.paused) tryPlay(v); }, ms);
      });
      clearInterval(timer);
    }, 150);
  }
  function visibleFraction(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return 0;
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var w = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
    var h = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    return (w * h) / (r.width * r.height);
  }
  function sweepGallery() {
    document.querySelectorAll('media-gallery deferred-media').forEach(function (dm) {
      if (visibleFraction(dm) < 0.5) return;
      var v = dm.querySelector('video');
      if (v) { if (v.paused) tryPlay(v); }
      else arm(dm);
    });
  }
  var cardIo = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { prepVideo(v); if (v.paused) tryPlay(v); }
      else if (!v.paused) v.pause();
    });
  }, { threshold: 0.1 }) : null;
  var galleryIo = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var dm = e.target;
      var v = dm.querySelector('video');
      if (v) { prepVideo(v); if (v.paused) tryPlay(v); }
      else arm(dm);
    });
  }, { threshold: 0.25 }) : null;
  function scan() {
    sweepGallery();
    document.querySelectorAll('media-gallery deferred-media').forEach(function (dm) {
      if (galleryIo) galleryIo.observe(dm);
      var v = dm.querySelector('video');
      if (v) prepVideo(v);
    });
    document.querySelectorAll('.card__media video').forEach(function (v) {
      if (v.closest('.moss-card-second-video')) return;
      prepVideo(v);
      if (!v.__mossLayerHook) {
        v.__mossLayerHook = true;
        v.addEventListener('playing', function () {
          var layer = v.closest('.moss-card-video');
          if (layer) layer.classList.add('is-on');
        });
      }
      if (cardIo) cardIo.observe(v);
    });
  }
  var scrollTimer = null;
  function onScrollOrTap() {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function () { scrollTimer = null; sweepGallery(); }, 160);
  }
  /* MOSS: desktop hover play/pause for second-media card videos
     (.moss-card-second-video). Delegated listeners, so cards injected later
     (facet re-renders, tabs) work too. The hosted <source> stays unloaded
     (data-src) until the first hover — nothing preloads. */
  var hoverMq = window.matchMedia('(hover: hover) and (pointer: fine)');
  var activeHoverVideo = null;
  var activeHoverCard = null;
  function hoverPlay(v) {
    if (!v) return;
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.loop = true;
    var s = v.querySelector('source[data-src]');
    if (s) {
      s.src = s.getAttribute('data-src');
      s.removeAttribute('data-src');
      try { v.load(); } catch (e) {}
    }
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function hoverPause(v) {
    if (v && !v.paused) v.pause();
  }
  document.addEventListener('mouseover', function (e) {
    if (!hoverMq.matches) return;
    var w = (e.target && e.target.closest) ? e.target.closest('.card-wrapper') : null;
    if (activeHoverCard && w !== activeHoverCard) {
      hoverPause(activeHoverVideo);
      activeHoverVideo = null;
      activeHoverCard = null;
    }
    if (!w || w === activeHoverCard) return;
    var layer = w.querySelector('.moss-card-second-video');
    var v = layer ? layer.querySelector('video') : null;
    if (v) {
      hoverPlay(v);
      activeHoverVideo = v;
      activeHoverCard = w;
    }
  });
  document.addEventListener('mouseout', function (e) {
    if (!activeHoverCard) return;
    var w = (e.target && e.target.closest) ? e.target.closest('.card-wrapper') : null;
    if (w === activeHoverCard && !(e.relatedTarget && w.contains(e.relatedTarget))) {
      hoverPause(activeHoverVideo);
      activeHoverVideo = null;
      activeHoverCard = null;
    }
  });
  function start() {
    scan();
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('deferred-media').then(function () { scan(); });
    }
    document.addEventListener('scroll', onScrollOrTap, true);
    document.addEventListener('touchend', onScrollOrTap, { passive: true });
    document.querySelectorAll('media-gallery').forEach(function (g) {
      var viewer = g.querySelector('[id^="GalleryViewer"]') || g;
      viewer.addEventListener('slideChanged', function (ev) {
        var el = ev.detail && ev.detail.currentElement;
        if (!el) return;
        [120, 500, 1100].forEach(function (delay) {
          setTimeout(function () {
            var dm = el.querySelector('deferred-media');
            if (!dm) return;
            var v = dm.querySelector('video');
            if (v) { prepVideo(v); if (v.paused) tryPlay(v); }
            else arm(dm);
          }, delay);
        });
      });
    });
    setInterval(function () {
      document.querySelectorAll('media-gallery deferred-media').forEach(function (dm) {
        if (visibleFraction(dm) < 0.5) return;
        var v = dm.querySelector('video');
        if (!v) { arm(dm); return; }
        prepVideo(v);
        if (v.paused && v.readyState >= 2) tryPlay(v);
        else if (v.paused && v.readyState < 2 && !v.__mossCanplayHook) {
          v.__mossCanplayHook = true;
          v.addEventListener('canplay', function () { if (v.paused) tryPlay(v); }, { once: true });
        }
      });
    }, 2500);
    window.addEventListener('resize', onScrollOrTap);
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('media-gallery')) onScrollOrTap();
    });
    var n = 0;
    var rescan = setInterval(function () { scan(); if (++n > 24) clearInterval(rescan); }, 700);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
